export interface InvestorNote {
  id?: string;
  investorId: string;
  commercialManagerId?: string;
  commercialManagerName?: string;
  fecha: string;
  categoria: string;
  comentario: string;
  proximoPaso?: string;
  esAutomatica: boolean;
  active?: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export const CATEGORIA_NOTA_OPTIONS = [
  { value: 'Seguimiento', label: 'Seguimiento' },
  { value: 'Llamada', label: 'Llamada Telefónica' },
  { value: 'Email', label: 'Email' },
  { value: 'Reunión', label: 'Reunión' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Documentación', label: 'Documentación' },
  { value: 'Incidencia', label: 'Incidencia' },
  { value: 'Oportunidad', label: 'Oportunidad de Negocio' },
  { value: 'Automático', label: 'Alerta Automática' },
];
